<div class="formly-field-wrap">
  @if(!options.formState.disabled && !field.props['disabled'] && !field.props['readonly']) {
    @if(field.type === 'TEXTAREA') {
      <textarea 
        appAutoResize
        placeholder="{{field.props.placeholder || field.props.label || '' | translate}}"
        class="active-input"
        [class.error]="formControl.invalid"
        [formControl]="$any(formControl)" 
        [formlyAttributes]="field"
        (input)="onValueChange($event)">
      </textarea>
    } @else if (field.type === 'TEXT') {
      <input 
        class="active-input" 
        [class.error]="formControl.invalid"
        type="{{field.props.type || 'text'}}"
        [min]="field.props.min || field.props['minDate'] || null"
        [max]="field.props.max || field.props['maxDate'] || null"
        placeholder="{{field.props.placeholder || field.props.label || '' | translate}}"
        autocomplete="true"
        [formControl]="$any(formControl)" 
        [formlyAttributes]="field"
        (input)="onValueChange($event)">
    }
    @if (field.props['maxLength']) {
      <div class="char-counter">
          {{ getCharacterCount() }}/{{ getMaxLength() }}
      </div>
    }
  } @else {
    <div [class]="(options.formState.showCompactViewWhenDisabled ? 'compact-' : '') + 'disabled-text'">
      {{field.props.type === 'password' ? (formControl.value ? '*******' : '') : formControl.value || ""}}
    </div>
  }
  <ng-template #fieldComponent></ng-template>
</div>